import React from 'react';

/**
 * Context for the step wizard.
 */
export const StepsContext = React.createContext(null);
